export default __webpack_public_path__ + "static/media/unPublic.9fe66b62.svg";